export default __webpack_public_path__ + "static/media/infographic.85272b04.png";